import { itemsEmptyCheck } from '@nf/utils-common/fpw/utils';

interface PeriodScoreboardProps {
	scores: Array<string>;
}

export const PeriodScoreboard = ({ scores }: PeriodScoreboardProps) => {
	return itemsEmptyCheck(scores).fold(
		() => null,
		() => (
			<div className="live-score-board">
				{scores.map((score, index) => (
					<div 
						key={index} 
						className="live-score-board__item"
					>
						{score}
					</div>
				))}
			</div>
		)
	);
};